"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M18.5,9.8H6.5C6.2,9.8,6,9.6,6,9.3s0.2-0.5,0.5-0.5h12.1C18.8,8.8,19,9,19,9.3S18.8,9.8,18.5,9.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M13.9,17.6h-2.8c-1.8,0-3.3-1.5-3.3-3.3v-5C7.7,9,8,8.8,8.2,8.8S8.7,9,8.7,9.3v5c0,1.3,1,2.3,2.3,2.3h2.8 c1.3,0,2.3-1,2.3-2.3v-5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v5C17.3,16.1,15.8,17.6,13.9,17.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M13.9,19.7h-2.8c-0.3,0-0.5-0.2-0.5-0.5v-2.1c0-0.3,0.2-0.5,0.5-0.5h2.8c0.3,0,0.5,0.2,0.5,0.5v2.1 C14.4,19.5,14.2,19.7,13.9,19.7z M11.6,18.7h1.8v-1.1h-1.8V18.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M12.5,21.2c-0.3,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.5-0.5S13,19,13,19.2v1.4 C13,20.9,12.8,21.2,12.5,21.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M9.7,9.8c-0.3,0-0.5-0.2-0.5-0.5v-5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v5C10.2,9.6,9.9,9.8,9.7,9.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M15.3,9.8c-0.3,0-0.5-0.2-0.5-0.5v-5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v5 C15.8,9.6,15.6,9.8,15.3,9.8z"
  }));
};

exports["default"] = _default;